import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const QuestionButton = () => {
  return (
    <Button
      type={"link"}
      href={"https://mayasolutions.de/anleitung-wer-bin-ich-web-app"}
      target={"_blank"}
    >
      <QuestionCircleOutlined />
    </Button>
  );
};
